import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=3f0254f2&"
import script from "./Create.vue?vue&type=script&async=true&defer=true&lang=js&"
export * from "./Create.vue?vue&type=script&async=true&defer=true&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports